import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText, JSXMapSerializer } from "@prismicio/react";

/**
 * Props for `BodyCopy`.
 */
export type BodyCopyProps = SliceComponentProps<Content.BodyCopySlice>;

const richTextComponents: JSXMapSerializer = {
  label: ({ node, children }) => {
    const label = node.data.label;

    if (label === "center-align") {
      return <span className="block text-center">{children}</span>;
    }

    if (label === "right-align") {
      return <span className="block text-right">{children}</span>;
    }

    if (label === "left-align") {
      return <span className="block text-left">{children}</span>;
    }

    return <span className={label}>{children}</span>;
  },
};

/**
 * Component for "BodyCopy" Slices.
 */
const BodyCopy: FC<BodyCopyProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`px-4 md:px-8 lg:px-12 2xl:px-0 ${slice.primary.background ? "bg-lightgrey" : ""} py-16`}
    >
      <div className="max-w-[820px] mx-auto font-fellix">
        <article className="max-w-none 
                            prose 
                            prose-p:font-fellix prose-p:text-[16px] prose-strong:font-bold prose-p:leading-[24px] prose-p:m-0 prose-p:p-0 prose-p:mb-4
                            prose-li:p-0 prose-li:pb-2 prose-li:m-0 prose-li:leading-[24px] prose-li:marker:text-jade prose-li:marker:text-[12px] 
                            prose-h1:!leading-[140%] 
                            prose-h2:!text-[28px] prose-h2:!leading-[36px] prose-h2:!p-0 prose-h2:!m-0 prose-h2:!mb-4 
                            prose-h5:font-semibold prose-h5:m-0 prose-h5:p-0 prose-h5:mb-2 prose-h5:mt-4
                            prose-h6:font-semibold prose-h6:m-0 prose-h6:p-0 prose-h6:mb-0 prose-h6:mt-4 prose-h6:text-[18px]
                            prose-a:text-blue prose-a:font-normal prose-a:cursor-pointer prose-a:no-underline prose-a:hover:underline">
          <PrismicRichText field={slice.primary.body_copy} components={richTextComponents} />
        </article>
      </div>
    </section>
  );
};

export default BodyCopy;
